import { render } from "./AddMessageButton.vue?vue&type=template&id=645fba8a"
import script from "./AddMessageButton.vue?vue&type=script&lang=js"
export * from "./AddMessageButton.vue?vue&type=script&lang=js"

import "./AddMessageButton.vue?vue&type=style&index=0&id=645fba8a&lang=css"

import exportComponent from "C:\\Users\\david\\Desktop\\Netloud\\whiteLabel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__